<template>
  <v-card>
    <v-container fluid grid-list-lg>
      <v-layout style="background: #efefef">
        <v-flex sm12 md12 class="align-start">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex
          sm12
          md12
          v-if="!loadingBillingCS && specialBillings.length > 0"
        >
          <v-layout justify-space-around align-end pt-2>
            <v-spacer />
            <!-- Copiar Faturas Atrasadas -->
            <v-tooltip bottom dark>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="tertiary"
                  small
                  icon
                  flat
                  @click.prevent="copyOverdueBillings"
                  v-on="on"
                >
                  <v-icon right>content_copy</v-icon>
                </v-btn>
              </template>
              <span color="white--text">Copiar faturas atrasadas</span>
            </v-tooltip>
          </v-layout>
        </v-flex>
      </v-layout>

      <div class="text-xs-center pt-5" v-if="loadingBillingCS">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>

      <v-data-table
        v-else
        :headers="headers"
        :items="specialBillings"
        class="elevation-0"
        :loading="loadingBillingCS"
        :search="search"
        rows-per-page-text="Linhas por página"
        :rows-per-page-items="rowsPerPage"
        no-data-text="Não há faturas"
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="props.item.reason === 'canceled_by_juntos'"
                  color="black"
                  size="16"
                  v-on="on"
                  icon
                  style="cursor: default"
                  class="mr-1"
                  >mdi-alert-circle-outline</v-icon
                >
              </template>
              <div>
                <p class="font-weight">
                  A fatura de débitos é composta da cobrança de faturas de
                  competências anteriores e parcelamentos não pagos
                </p>
              </div>
            </v-tooltip>
            {{ formatReason(props.item.reason) }}
          </td>
          <td>{{ props.item.due_date | dueDate }}</td>
          <td>R${{ props.item.total | formatCurrency }}</td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  :color="props.item.status | statusColor"
                  @click.prevent="
                    openBillingDetail = true;
                    transaction_id = props.item.id;
                  "
                >
                  {{ props.item.status | statusIcon }}
                </v-icon>
              </template>
              <span>{{ formatStatus(props.item) || "x" }}</span>
            </v-tooltip>
          </td>
        </template>

        <template v-slot:pageText="props">
          Linha {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}
        </template>

        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Sua busca por "{{ search }}" não encontrou resultados.
          </v-alert>
        </template>
      </v-data-table>

      <v-snackbar
        v-model="snackbar.value"
        :multi-line="snackbar.mode === 'multi-line'"
        :timeout="snackbar.timeout"
        :top="snackbar.top"
        :color="snackbar.color"
      >
        {{ snackbar.message }}
        <v-btn color="white" flat @click="snackbar.value = false">Fechar</v-btn>
      </v-snackbar>

      <v-dialog v-model="calendarDialog" max-width="600">
        <v-card class="calendar-card">
          <v-card-title class="headline"
            >Alterar Data de Vencimento</v-card-title
          >
          <v-card-text class="calendar-container">
            <v-menu
              v-model="openCalendar"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="newDueDate"
                  label="Nova data de Vencimento"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                dark
                v-model="newDueDate"
                :min="actualDueDate"
                :max="maxDate"
                :allowed-dates="allowedDates"
                @input="openCalendar = false"
              />
            </v-menu>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="calendarDialog = false"
              >Cancelar</v-btn
            >
            <v-btn color="green" text @click="changeDueDate">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="parentBillingDialog" max-width="600px" persistent lazy>
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            <v-layout align-center justify-end row fill-height>
              <v-flex xs12 md11>
                <span class="headline"
                  >Faturas que compõem o boleto: {{ totalParentBillings }}</span
                >
              </v-flex>
              <v-flex xs12 md1>
                <v-btn
                  icon
                  dark
                  flat
                  color="error"
                  @click="parentBillingDialog = false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-progress-linear
            class="pa-0 ma-0"
            v-model="progress"
            :height="4"
          ></v-progress-linear>
          <v-data-table
            :headers="[
              { text: '#', value: 'index' },
              { text: 'UC', value: 'consumer_unit' },
              { text: 'Competência', value: 'competence' },
              { text: 'Valor (R$)', value: 'total', align: 'right' },
              { text: 'ID', value: 'id' },
            ]"
            :items="parentBillings"
            class="elevation-0"
            hide-actions
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td>{{ props.item.consumer_unit }}</td>
              <td>{{ props.item.competence }}</td>
              <td class="text-xs-right">
                {{ props.item.total | formatCurrency }}
              </td>
              <td>{{ props.item.id }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-dialog>
      <cpnDetalhesFaturaEspecial
        :rightSpecial="openBillingDetail"
        :debtBillingID="transaction_id"
        @closeDialog="openBillingDetail = false"
      />
    </v-container>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import { mapActions, mapGetters, mapState } from "vuex";
import firestore from "../../../firebase/firestore";
import { calendarMixin } from "../../../mixin/calendarMixin";
import { updateSpecialBilling } from "../../../services/billing";
import { getPermission } from "../../../services/permissions";
import DetalhesFaturaEspecial from "../../faturaDetails/DetalhesFaturaEspecial.vue";

export default {
  props: ["consumerUnit"],

  components: { cpnDetalhesFaturaEspecial: DetalhesFaturaEspecial },

  mixins: [calendarMixin],

  data() {
    return {
      openBillingDetail: false,
      transaction_id: "",
      loadingChange: false,
      parentBillings: [],
      parentBillingDialog: false,
      totalParentBillings: 0,
      calendarDialog: false,
      openCalendar: false,
      actualId: null,
      actualDueDate: null,
      hasChangedDueDate: null,
      newDueDate: null,
      progress: 0,
      rowsPerPage: [12, 24],
      search: "",
      headers: [
        {
          text: "Tipo",
          value: "reason",
        },
        {
          text: "Data de vencimento",
          align: "left",
          sortable: true,
          value: "due_date",
        },
        {
          text: "Valor",
          align: "left",
          value: "total",
        },
        { text: "Status", value: "status" },
      ],
      pagination: {
        sortBy: "due_date",
        descending: true,
      },
      snackbar: {
        timeout: 6000,
        value: false,
        message: "",
        color: "",
        top: false,
        botton: false,
        mode: "",
      },
    };
  },

  computed: {
    ...mapGetters("cs", ["specialBillings", "userCS", "billingsById"]),
    ...mapState("cs", ["activeBilling", "loadingBillingCS"]),
    ...mapState(["config", "user"]),

    maxDate() {
      if (!this.actualDueDate) return dayjs().toISOString();
      return dayjs(this.actualDueDate).add(60, "day").toISOString();
    },

    isAdmin() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("admin") >= 0;
    },

    isFinancial() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("financial") >= 0;
    },
  },

  async mounted() {
    if (this.specialBillings) await this.getSpecialBillings(this.consumerUnit);
    if (
      this.activeBilling &&
      this.activeBilling === 1 &&
      this.specialBillings.length <= 0
    ) {
      this.pagination.descending = !this.pagination.descending;
    }
    if (this.isAdmin || this.isFinancial) {
      const date = new Date();
      const config_date = (
        await firestore.collection("config").doc("segunda_via").get()
      ).data().max_days_admin;
      date.setDate(date.getDate() + (config_date ?? 60));
      this.maxDateChangeExpire = date.toISOString();
    } else {
      const date = new Date();
      const config_date = (
        await firestore.collection("config").doc("segunda_via").get()
      ).data().max_days_internal;
      date.setDate(date.getDate() + (config_date ?? 15));
      this.maxDateChangeExpire = date.toISOString();
    }
  },

  watch: {
    async "consumerUnit.id"() {
      if (this.specialBillings)
        await this.getSpecialBillings(this.consumerUnit);
    },
  },

  methods: {
    ...mapActions("cs", ["getSpecialBillings", "getBillings"]),

    async changeDueDate() {
      const permission = await getPermission(
        "change_special_billing_due_date",
        this.user.id,
      );

      if (!permission.data.has_permission) {
        this.calendarDialog = false;
        this.showSnackBar(
          "Usuário sem permissão para realizar essa ação",
          "top",
          "red",
        );
        return;
      }

      if (this.hasChangedDueDate) {
        this.calendarDialog = false;
        this.showSnackBar(
          "Data de vencimento já foi alterada uma vez",
          "top",
          "red",
        );
        return;
      }
      const data = {
        due_date: this.newDueDate,
        has_changed_due_date: true,
        status: "reprocessing",
        change_due_date_agent: {
          id: this.user.id,
          name: this.user.name,
          email: this.user.email,
        },
      };
      updateSpecialBilling(this.actualId, data);
      await this.getSpecialBillings(this.consumerUnit);
      this.calendarDialog = false;
      this.showSnackBar(
        "Data de vencimento alterada com sucesso!",
        "top",
        "green",
      );
    },

    openDueDateCalendar(specialBilling) {
      this.actualId = specialBilling.id;
      this.hasChangedDueDate = specialBilling.has_changed_due_date;
      this.actualDueDate = dayjs(specialBilling.due_date).toISOString();
      this.calendarDialog = true;
    },

    showSnackBar(msg, direction, color) {
      this.snackbar.message = msg;
      this.snackbar.top = direction === "top";
      this.snackbar.botton = direction === "botton";
      this.snackbar.color = color;
      this.snackbar.value = true;
    },

    selectText(item) {
      return (
        item.due_date +
        " — R$" +
        (parseFloat(item.total) || 0).toFixed(2) +
        " — " +
        this.formatStatus(item)
      );
    },

    formatStatus(billing) {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() - 1);

      if (billing.status === "") return "xxx";
      else if (billing.status === "paid" || billing.status === "succeeded")
        return "Paga";
      else if (billing.status === "pending") return "Processar";
      else if (billing.status === "refused") return "Recusada";
      else if (billing.status === "pending_approval") return "Em Análise";
      else if (billing.status === "reprocessing") return "Reprocessando";
      else if (billing.status === "generating") return "Gerando";
      else if (billing.status === "opened") return "Aberto";
      else if (billing.status === "canceled") return "Expirado";
      else if (billing.status === "overdue") return "Atrasada";
      else if (billing.status === "generation_failed") return "Falha ao gerar";
      else if (billing.status === "validation_failed") return "Inválido";
      else if (billing.status === "in_queue") return "Programado";
      else if (billing.status === "error") return "Erro";
      else if (billing.status === "free") return "Abonado";
      else if (billing.status === "refunded") return "Reembolsado";
      else if (billing.status === "negotiated") return "Negociado";
      else if (billing.status === "parceled") return "Parcelado";
      else if (billing.status === "waiting_payment") return "Aberta";
      else if (billing.status === "free_pending") return "Pendente para Abono";
      else if (billing.status === "postponed")
        return "O valor da fatura será cobrado nas próximas faturas";
      else return billing.status;
    },

    formatReason(billingReason) {
      if (billingReason === "deal") return "Campanhas/Acordos";
      else if (billingReason === "fine") return "Multa de cancelamento";
      else if (billingReason === "joined_billings") return "Junção de Faturas";
      else if (billingReason === "closing_billing")
        return "Fatura de Encerramento";
      else if (billingReason === "canceled_by_juntos")
        return "Fatura de débitos";
      else if (billingReason === "other") return "Outros";
      else return billingReason;
    },

    copyOverdueBillings() {
      const overdueBillings = this.specialBillings.filter(
        (billing) => billing.status === "overdue",
      );

      if (overdueBillings.length <= 0) {
        this.showSnackBar("Membro não possui faturas atrasadas!", "top", "red");
        return;
      }
      let overdueBillingsText = "";
      for (const billing of overdueBillings) {
        let splitCompetence = billing.due_date.split("-");
        let formattedCompetence =
          splitCompetence[2] +
          "/" +
          splitCompetence[1] +
          "/" +
          splitCompetence[0];
        let formattedTotal = "R$ " + billing.total.toFixed(2).replace(".", ",");
        overdueBillingsText +=
          formattedCompetence + " - " + formattedTotal + "\n";
      }

      navigator.clipboard.writeText(overdueBillingsText);
      this.showSnackBar("Copiado para área de transferência", "top", "green");
    },

    copyBillingId(id) {
      navigator.clipboard.writeText(id);
      this.showSnackBar("Copiado para área de transferência", "top", "green");
    },

    async setParentBillingsData(billing) {
      const parent_billings = billing.parent_billings;
      this.totalParentBillings = parent_billings.length;
      this.progress = 0;
      this.parentBillings = [];
      this.parentBillingDialog = true;
      for (const i in parent_billings) {
        // para o carregamento caso o dialog seja fechado
        if (!this.parentBillingDialog) break;
        const id = parent_billings[i];
        let parent = this.billingsById(id);
        if (!parent) {
          parent = (await firestore.collection("billing").doc(id).get()).data();
        }
        this.parentBillings.push(
          parent || {
            id: id,
            competence: "-",
            total: null,
            consumer_unit: "-",
          },
        );
        this.progress = (i / (this.totalParentBillings - 1)) * 100;
      }
    },
  },

  filters: {
    dueDate(value) {
      if (!value) return "";
      let comp = value.split("-");
      return comp[2] + "/" + comp[1] + "/" + comp[0];
    },

    statusIcon(value) {
      if (!value) return "";
      if (value === "paid" || value === "succeeded") {
        return "done";
      } else if (value === "refused") {
        return "error";
      } else if (value === "generating") return "hourglass_top";
      else if (value === "opened" || value === "waiting_payment")
        return "schedule";
      else if (value === "canceled") return "watch_later";
      else if (value === "overdue") return "alarm";
      else if (value === "generation_failed") return "report_problem";
      else if (value === "validation_failed") return "report_problem";
      else if (value === "free") return "card_giftcard";
      else if (value === "error") return "error";
      else if (value === "reprocessing") return "history";
      else if (value === "pending_approval") return "pending_actions";
      else if (value === "in_queue") return "history_toggle_off";
      else if (value === "refunded") return "keyboard_return";
      else if (value === "negotiated") return "gavel";
      else if (value === "parceled") return "list";
      else if (value === "free_pending") return "card_giftcard";
      else if (value === "postponed") return "currency_exchange";
      else {
        return "alarm";
      }
    },

    statusColor(value) {
      if (!value) return "";
      if (value === "paid" || value === "succeeded") {
        return "green";
      } else if (value === "refused") {
        return "orange";
      } else if (value === "generating") return "blue";
      else if (value === "opened" || value === "waiting_payment") return "grey";
      else if (value === "canceled") return "black";
      else if (value === "overdue") return "red";
      else if (value === "generation_failed") return "orange";
      else if (value === "validation_failed") return "orange";
      else if (value === "free") return "blue";
      else if (value === "reprocessing") return "red";
      else if (value === "pending_approval") return "blue";
      else if (value === "error") return "red";
      else if (value === "in_queue") return "blue";
      else if (value === "refunded") return "blue";
      else if (value === "negotiated") return "blue-grey";
      else if (value === "parceled") return "blue-grey";
      else if (value === "postponed") return "#FFD700";
      else {
        return "grey";
      }
    },

    formatCurrency(value) {
      if (value === undefined || value === null) return "-";
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style scoped>
.noPadding {
  padding: 0 !important;
}

.calendar-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.calendar-container {
  display: flex;
  justify-content: center;
}
.v-btn.round {
  border-radius: 50%;
  height: 40px;
  width: 40px;
  padding: 0%;
}
</style>
